import actions from '../../constants/actionTypes';
import request from '../../utils/request';
import {
  initializeApp,
  startAppLoading,
  stopAppLoading,
} from '../../layout/actions';
import {
  resetAuthentication,
  setAuthentication,
} from '../../authentication/actions';
import {
  aesCbcEncryptPskc,
  createKeyShaPassword,
  hashPassword,
  isSuccess,
} from '../../utils/utils';
import { trans } from '../../localization/index';
import {
  setGeneralError,
  setGeneralSuccess,
} from '../../layout/components/UniversalModal/actions';

export function requestLogin() {
  return {
    type: actions.REQUEST_LOGIN,
  };
}

export function loginSuccess() {
  return {
    type: actions.LOGIN_SUCCESSFULLY,
  };
}

export function socialLogin(token, type) {
  return dispatch => {
    dispatch(requestLogin());
    dispatch(startAppLoading());
    return request
      .postAuth('/api/auth/social_login', {
        token,
        login_type: type,
      })
      .then(response => {
        dispatch(stopAppLoading());
        if (isSuccess(response)) {
          dispatch(setAuthentication(response.reply));
          dispatch(loginSuccess());
          dispatch(initializeApp());
        }
      });
  };
}

export function manualLogin(account, password, callBackFailAction) {
  return dispatch => {
    dispatch(requestLogin());
    dispatch(startAppLoading());
    return request
      .postAuth('/api/auth/prelogin', { account })
      .then(preResponse => {
        if (preResponse.result === 'success') {
          const { salt, verify_code: verifyCode } = preResponse.reply;
          const body = {
            account,
            password: hashPassword(password, salt, verifyCode),
          };
          return request
            .postAuth('/api/auth/secure_login', body)
            .then(responseAuth => {
              dispatch(stopAppLoading());
              if (responseAuth.result === 'success') {
                dispatch(setAuthentication(responseAuth.reply));
                dispatch(loginSuccess());
                dispatch(initializeApp());
              } else {
                callBackFailAction(trans(responseAuth.result));
              }
            });
        } else if (preResponse.result === 'error_defined_message') {
          callBackFailAction(trans(preResponse.reply.error_message));
        } else {
          callBackFailAction(trans(preResponse.result));
        }
        return dispatch(stopAppLoading());
      });
  };
}

export function changePassword({ currentPassword, newPassword }) {
  return dispatch => {
    dispatch(startAppLoading());
    return request
      .postAuth('/api/auth/pre_change_password')
      .then(preResponse => {
        if (isSuccess(preResponse)) {
          const { salt, verify_code: verifyCode } = preResponse.reply;
          const keySha = createKeyShaPassword(
            currentPassword,
            salt,
            verifyCode,
          );
          const body = {
            current_password: aesCbcEncryptPskc(currentPassword, keySha),
            new_password: aesCbcEncryptPskc(newPassword, keySha),
          };
          return request
            .postAuth('/api/auth/secure_change_password', body)
            .then(responseAuth => {
              dispatch(stopAppLoading());
              if (isSuccess(responseAuth)) {
                dispatch(resetAuthentication());
                dispatch(setGeneralSuccess('set_change_password_success'));
                return true;
              }
              dispatch(setGeneralError(responseAuth.result));
              return false;
            });
        }
        dispatch(stopAppLoading());
        dispatch(setGeneralError(preResponse.result));
        return false;
      });
  };
}



// WEBPACK FOOTER //
// ./foody/src/pages/Login/actions.jsx